export default "__VITE_ASSET__BB8_ByWL__"